// @ts-nocheck

export const localeCodes =  [
  "en",
  "uk",
  "ru",
  "de",
  "fr",
  "pl",
  "es",
  "pt",
  "bg",
  "ro",
  "sr",
  "hr",
  "bs",
  "sq",
  "lt",
  "lv",
  "hy",
  "az",
  "id",
  "ms",
  "hi",
  "bn",
  "ta",
  "te",
  "mr",
  "ml",
  "th",
  "af",
  "fi",
  "ht",
  "it",
  "ge",
  "ru-VS"
]
export const localeLoaders = {
  en: [],
  uk: [],
  ru: [],
  de: [],
  fr: [],
  pl: [],
  es: [],
  pt: [],
  bg: [],
  ro: [],
  sr: [],
  hr: [],
  bs: [],
  sq: [],
  lt: [],
  lv: [],
  hy: [],
  az: [],
  id: [],
  ms: [],
  hi: [],
  bn: [],
  ta: [],
  te: [],
  mr: [],
  ml: [],
  th: [],
  af: [],
  fi: [],
  ht: [],
  it: [],
  ge: [],
  "ru-VS": []
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    language: undefined
  },
  {
    code: "uk",
    name: "Українська",
    language: undefined
  },
  {
    code: "ru",
    name: "Русский",
    language: undefined
  },
  {
    code: "de",
    name: "Deutsch",
    language: undefined
  },
  {
    code: "fr",
    name: "Français",
    language: undefined
  },
  {
    code: "pl",
    name: "Polski",
    language: undefined
  },
  {
    code: "es",
    name: "Español",
    language: undefined
  },
  {
    code: "pt",
    name: "Português",
    language: undefined
  },
  {
    code: "bg",
    name: "Български",
    language: undefined
  },
  {
    code: "ro",
    name: "Română",
    language: undefined
  },
  {
    code: "sr",
    name: "Srpski",
    language: undefined
  },
  {
    code: "hr",
    name: "Hrvatski",
    language: undefined
  },
  {
    code: "bs",
    name: "Bosanski",
    language: undefined
  },
  {
    code: "sq",
    name: "Shqip",
    language: undefined
  },
  {
    code: "lt",
    name: "Lietuvių",
    language: undefined
  },
  {
    code: "lv",
    name: "Latviešu",
    language: undefined
  },
  {
    code: "hy",
    name: "Հայերեն",
    language: undefined
  },
  {
    code: "az",
    name: "Azərbaycanca",
    language: undefined
  },
  {
    code: "id",
    name: "Bahasa Indonesia",
    language: undefined
  },
  {
    code: "ms",
    name: "Bahasa Melayu",
    language: undefined
  },
  {
    code: "hi",
    name: "हिन्दी",
    language: undefined
  },
  {
    code: "bn",
    name: "বাংলা",
    language: undefined
  },
  {
    code: "ta",
    name: "தமிழ்",
    language: undefined
  },
  {
    code: "te",
    name: "తెలుగు",
    language: undefined
  },
  {
    code: "mr",
    name: "मराठी",
    language: undefined
  },
  {
    code: "ml",
    name: "മലയാളം",
    language: undefined
  },
  {
    code: "th",
    name: "ภาษาไทย",
    language: undefined
  },
  {
    code: "af",
    name: "Afrikaans",
    language: undefined
  },
  {
    code: "fi",
    name: "Suomi",
    language: undefined
  },
  {
    code: "ht",
    name: "Kreyòl ayisyen",
    language: undefined
  },
  {
    code: "it",
    name: "Italiano",
    language: undefined
  },
  {
    code: "ge",
    name: "ქართული",
    language: undefined
  },
  {
    code: "ru-VS",
    name: "Русский (VS)",
    language: undefined
  }
]

